import { GestesDuLien } from '../moteur/conditions';
import { LIEN_CACHE, LIENS } from '../partage/vocabulaire';
import { TitreDuLien, useConditionsDeLaBulle } from './Dependances';
import { RubriqueDeLaFace } from './FaceDeLaFiche';
import { lignesDesLiens, projetDuLien, type CoteDuLien } from './lignesDesLiens';

/**
 * Le bloc « Liens » de la fiche Plan (chantier liens-entre-bulles, ticket 05, décision 13 du
 * cadrage ; spec du chantier, « La fiche ») : ce qui n'est pas une condition, « Sert à »,
 * « S'appuie sur », « Touche à », cachés compris. Chaque ligne : l'autre bulle (un clic ouvre sa
 * fiche), son projet s'il diffère, « caché » s'il l'est sur la carte, et les signes de la carte
 * (`GestesDuLien`) : l'œil, ⇄ (pas pour « touche à »), la croix. Sans lien, le bloc est absent.
 * On n'y pose pas de lien : « Lier », sur la carte, le fait.
 */
export function LiensDeLaFiche({ bulleId, onAutreBulle }: { bulleId: string; onAutreBulle?: (id: string) => void }) {
  const { autres } = useConditionsDeLaBulle(bulleId);
  const groupes = lignesDesLiens(autres);
  if (groupes.length === 0) return null;

  return (
    <RubriqueDeLaFace titre={LIENS}>
      <div className="dependances liens-de-la-fiche">
        {groupes.map((groupe) => (
          <div key={groupe.cote} className="liens-de-la-fiche-groupe" data-cote={groupe.cote}>
            <p className="dependances-intertitre">{groupe.titre}</p>
            {groupe.liens.map((lien) => {
              const projet = projetDuLien(lien);
              return (
                <div key={lien.lienId} className={`dependance${lien.visible ? '' : ' dependance--cachee'}`} data-lien={lien.lienId}>
                  <FlecheDuCote cote={groupe.cote} />
                  <TitreDuLien titre={lien.titre} id={lien.id} onAutreBulle={onAutreBulle} />
                  {projet && <span className="dependance-mention">{projet}</span>}
                  {!lien.visible && <span className="dependance-mention dependance-cache">{LIEN_CACHE}</span>}
                  <span className="dependance-gestes">
                    <GestesDuLien lien={lien} echapAnnule />
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </RubriqueDeLaFace>
  );
}

/**
 * Le trait de la carte, en petit (chantier liens-entre-bulles, ticket 03) : « sert à » plein et
 * fléché, vers l'autre ou depuis l'autre ; « touche à » plein, sans flèche.
 */
function FlecheDuCote({ cote }: { cote: CoteDuLien }) {
  const trait = cote === 'touche_a' ? 'M2.6 8.5h11.8' : cote === 'sert_a' ? 'M2.6 8.5h11M9.6 4.5l4 4-4 4' : 'M14.4 8.5h-11M7.4 4.5l-4 4 4 4';
  return (
    <svg width="16" height="16" viewBox="0 0 17 17" fill="none" aria-hidden="true">
      <path d={trait} stroke="var(--transversale)" strokeWidth="1.4" />
    </svg>
  );
}
